module.exports = ".sidebar-wrapper .sidebar-menu ul li a i{\r\n    font-size: 14px\r\n}"